export default "__VITE_ASSET__zos$p4Zs__"